import axios from "axios";

const BASE_URL = "https://buzzmobile-app.herokuapp.com/api";
// const BASE_URL = "http://localhost:5000/api";

// https://buzzmobile-app.herokuapp.com/api/products?category=telefoni&new=true

export const getFeaturedProducts = async (products) => {
  try {
    const res = await axios.get(`${BASE_URL}${products}`);

    return res.data;
  } catch (err) {
    return err;
  }
};

export const getSingleProduct = async (id) => {
  try {
    const res = await axios.get(`${BASE_URL}/products/find/${id}`);

    return res.data;
  } catch (err) {
    return null;
  }
};

export const getSingleProductBySlug = async (slug) => {
  try {
    const res = await axios.get(
      `${BASE_URL}/products/slug/${encodeURIComponent(slug)}`
    );

    return res.data;
  } catch (err) {
    return null;
  }
};

export const getSingleProductAcc = async (id) => {
  try {
    const res = await axios.get(`${BASE_URL}/accessories/find/${id}`);

    return res.data;
  } catch (err) {
    return null;
  }
};

export const getSingleProductAccBySlug = async (slug) => {
  try {
    const res = await axios.get(
      `${BASE_URL}/accessories/slug/${encodeURIComponent(slug)}`
    );

    return res.data;
  } catch (err) {
    return null;
  }
};

export const getProductsByBrand = async (brand) => {
  try {
    const res = await axios.get(`${BASE_URL}/products?brand=${brand}`);

    return res.data;
  } catch (err) {
    return err;
  }
};

export const getProductsByCategory = async (category) => {
  try {
    const res = await axios.get(`${BASE_URL}/accessories?category=${category}`);

    return res.data;
  } catch (err) {
    return err;
  }
};

export const getSearchResults = async (searchName) => {
  try {
    const res = await axios.get(
      `${BASE_URL}/products/search?title=${searchName}`
    );
    return res.data;
  } catch (err) {
    return err;
  }
};

export const submitOrder = async (order) => {
  try {
    const res = await axios.post(`${BASE_URL}/orders`, order);
    return res;
  } catch (err) {
    return err;
  }
};

export const subscribe = async (email) => {
  try {
    const res = await axios.post(`${BASE_URL}/subscribe`, email);

    return res;
  } catch (err) {
    return err.response.data.code;
  }
};

export const getServicePhones = async () => {
  try {
    const res = await axios.get(`${BASE_URL}/service-phones`);
    return res.data;
  } catch (err) {
    return [];
  }
};

export const getPhoneFinderRecommendations = async (answers) => {
  try {
    const res = await axios.post(`${BASE_URL}/products/phone-finder`, answers);
    return res.data;
  } catch (err) {
    return null;
  }
};

export const getPhoneFinderOptions = async () => {
  try {
    const res = await axios.get(`${BASE_URL}/products/phone-finder/options`);
    return res.data;
  } catch (err) {
    return null;
  }
};

export const getServiceTrackingStatus = async (trackId) => {
  try {
    const res = await axios.get(
      `https://buzz-mobile-inventory-d3b6d40f3c32.herokuapp.com/api/services/track/${encodeURIComponent(trackId)}`
    );

    return {
      ok: true,
      data: res.data,
    };
  } catch (err) {
    return {
      ok: false,
      status: err?.response?.status || null,
      message:
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        "Настана грешка при поврзувањето со серверот.",
    };
  }
};

export const getBlogPosts = async () => {
  try {
    const res = await axios.get(`${BASE_URL}/blog`);
    return Array.isArray(res.data) ? res.data : [];
  } catch (err) {
    return [];
  }
};

export const getBlogPostBySlugFromApi = async (slug) => {
  try {
    const res = await axios.get(`${BASE_URL}/blog/${encodeURIComponent(slug)}`);
    return res.data;
  } catch (err) {
    return null;
  }
};
